import Helmet from "react-helmet";
import Footer from "./Footer";

const AuthLayout = ({ children, title }) => {
  return (
    <>
      <Helmet>
        <link rel="preconnect" href="https://fonts.googleapis.com" />
        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
        <link
          href="https://fonts.googleapis.com/css2?family=Archivo:wght@700&family=Outfit:wght@500;600&display=swap"
          rel="stylesheet"
        />
      </Helmet>
      <div className="auth-page">
        <div className="auth-page__panel">
          <div className="logotype">
            <img src="/logotype.png" alt="EverTask logotype" />
          </div>
          <h1 className="title">{title}</h1>
          {children}
        </div>
      </div>
      <Footer />
    </>
  );
};

export default AuthLayout;
